<h1>{{ 'draw-stats.title' | translate }}</h1>
<p>
	<span class="subtitle" [innerHTML]="'draw-stats.subtitle' | translate | hgSafeHtml"></span>
</p>

<ra-draw-stats-list></ra-draw-stats-list>